export const UPCONNECT_TASK = {
  RESET: "RESET",
  OPEN_RECIPE: "OPEN_RECIPE",
};
